<template>
  <div class="head-page">
    <Header :title="$t('lockming.tolockming')" />
    <div class="head-page-overflow" style="padding-bottom: 50px">
      <div class="loan-area">
        <div class="title-box">
          <div class="icon"><img src="../../assets//logod.png" /></div>
          <div class="title">{{ itemdata.title }}</div>
        </div>
      </div>
      <div class="loan-area">
        <div class="desc" style="position: relative;display:inline-flex;">
          <div>
          {{ $t("lockming.days") }} :&nbsp;&nbsp; <span style="display: none;">{{ itemdata.cycle }} {{ $t("common.day") }}</span>
          </div>
          <div class="days-box">
            <ul>
              <li v-for="(item,index) in itemdata.cycle.split(',')" :key="index" @click="changeDay(index)">
                <van-tag :plain="dayIndex != index" type="primary" size="medium">{{ item }}天</van-tag>
              </li>
            </ul>
          </div>
        </div>
        <p class="desc">
          {{ $t("lockming.locknum") }} : {{ itemdata.min_price }} - {{ itemdata.max_price }}
        </p>
      </div>
      <div class="loan-area">
        <van-cell :title="$t('lockming.getforday')">
          <template #default>  {{ interest_rate }} % </template>
        </van-cell>
        <van-cell :title="$t('lockming.estimation')">
          <template #default>
            {{ parseFloat(lixi).toFixed(8) }} {{ itemdata.coin_title }}
          </template>
        </van-cell>
        <van-cell :title="$t('lockming.balance')">
          <template #default>
            {{ parseFloat(balance).toFixed(8) }} {{ itemdata.coin_title }}
          </template>
        </van-cell>
        <van-cell :title="$t('lockming.nums')">
          <template #default>
            <van-stepper
            @change="amountChange"
              v-model="frm.amount"
              :min="itemdata.min_price"
              :max="itemdata.max_price"
              theme="round"
              integer
              input-width="80px"
              button-size="32px"
            />
          </template>
        </van-cell>
      </div>
    </div>
    <LoanFoot
      :money="frm.amount"
      :posting="posting"
      :btnName="$t('lockming.tolockming')"
      @page-submit="toSub"
    />
  </div>
</template>
  
  <script>
import Header from "@/components/Header";
import LoanFoot from "../LoansView/components/footer.vue";
export default {
  name: "LockmingApplication",
  components: { Header, LoanFoot },
  data() {
    return {
      dayIndex: null,
      interest_rate:null,
      itemdata: {},
      money: 100,
      id: null,
      balance: 0,
      lixi: 0,
      posting:false,
      frm: {
        id: null, //	是	int	贷款项目id
        amount: null, //	是	int	申请金额
        day:null, //购买天数
        interest_rate:null //购买日利率
      },
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getData();
    }
  },
  methods: {
    changeDay(index){
      this.dayIndex = index
      const interestRateArr = this.itemdata.interest_rate.toString().split(',')
      if(Object.prototype.toString.call(interestRateArr).slice(8, -1).toLowerCase() == 'array'){
        if(index >= interestRateArr.length)
          this.interest_rate = interestRateArr[interestRateArr.length - 1]
        else
          this.interest_rate = interestRateArr[index]
      } else {
         this.interest_rate = this.itemdata.interest_rate
      }
      this.frm.day = this.itemdata.cycle.split(',')[index]
      this.frm.interest_rate = this.interest_rate
      this.amountChange(this.frm.amount)
    },
    toSub() {
      this.toSubmit();
    },
    async toSubmit() {
      if (
        this.frm.amount < this.itemdata.minprice ||
        this.frm.amount > this.itemdata.maxprice
      ) {
        this.$toast.fail(
          this.$t("loans.Expected_loan_amounterror", {
            min: this.itemdata.minprice,
            max: this.itemdata.maxprice,
          })
        );
        return;
      }
      if (this.posting) {
        return;
      }
      this.posting = true;
      await this.$http({
        method: "post",
        url: "buyMiningMachine",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.frm.amount = this.itemdata.min_price;
          this.amountChange(this.frm.amount)
        })
        .catch(() => {
          this.posting = false;
        });
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getMiningMachineList",
        data: { id: this.id },
      }).then((res) => {
        this.itemdata = res.data.list[0];
        if (this.itemdata) {
          this.frm.amount = this.itemdata.min_price;
          this.changeDay(0)
          
          this.frm.id = this.itemdata.id;
          this.getBalance()
         
        }
      });
    },
    async getBalance(){
      await this.$http({
        method: "post",
        url: "getCoinBalance",
        data: { c_id: this.itemdata.c_id },
      }).then((res) => {
        res.data.balance_list.forEach(element => {
          if(element.type == 1)this.balance = element.balance
        });
      });
    },
    amountChange(val){
      this.lixi = parseFloat(val) * parseFloat(this.frm.interest_rate) * parseFloat(this.frm.day) / 100
    }
  },
};
</script>
  
  <style>
</style>
  